export enum EStatusColor {
    'active' = '#4caf50',
    'inactive' = '#f44336',
    'pending' = '#ff9800',
}

export enum ERiskColor {
    'Low' = 'green',
    'Medium' = 'orange',
    'High' = 'red',
}

export enum EClientType {
    PARENT = 'Parent',
    SCHOOL = 'school',
    CORPORATE = 'Corporate',
    ORGANISATION = 'organisation',
}

export enum EBudgetUnit {
    Lakhs = 'lakhs',
    Crores = 'crores',
}

export enum EClientVerticalType {
    NATIONAL = 'national',
    REGIONAL = 'regional',
    INTERNATIONAL = 'international',
}

export enum EOrganisationType {
    SCHOOL = 'school',
}

export enum EUploadStep {
    SELECT_FILE = 'SELECT_FILE',
    UPLOAD = 'UPLOAD',
    VALIDATION = 'VALIDATION',
    DUPLICATE_RESOLUTION = 'DUPLICATE_RESOLUTION',
    CONFIRMATION = 'CONFIRMATION',
    SUCCESS = 'SUCCESS',
}

export enum EDuplicateResolution {
    DUPLICATE = 'duplicate',
    NEW = 'new',
}

export enum EValidationType {
    REQUIRED = 'required',
    STRING = 'string',
    EMAIL = 'email',
    URL = 'url',
    MOBILE = 'mobile',
    NUMERIC = 'numeric',
    MIN_LENGTH = 'min_length',
    MAX_LENGTH = 'max_length',
    PATTERN = 'pattern',
    MIN_VALUE = 'min_value',
    MAX_VALUE = 'max_value',
    DECIMAL = 'decimal',
    PINCODE = 'pincode',
}

export interface IValidationRule {
    type: EValidationType
    value?: string | undefined | number | RegExp
    message?: string
}

export interface IFieldValidation {
    fieldName: string
    rules: IValidationRule[]
}

export enum EValidationField {
    CLIENT_NAME = 'Customer Name',
    STUDENT_NAME = "Student's Name",
    CURRICULUM = 'Curriculum',
    INTERESTED_PRODUCTS = 'Interested Products',
    INTERESTED_PRODUCTS_EDTECH = 'Interested Products - Edtech',
    INTERESTED_PRODUCTS_LIBRARY = 'Interested Products - Library',
    INTERESTED_PRODUCTS_SMART_CLASS = 'Interested Products - Smart Class',
    SCHOOL_NAME = 'School Name',
    CLASS = 'Class',
    WEBSITE = 'Website',
    EMAIL_ID = 'Email ID',
    MOBILE_NUMBER = 'Mobile Number',
    CONTACT_NAME = 'Contact Name',
    ROLE_DESIGNATION = 'Role/Designation',
    SHIPPING_PINCODE = 'Shipping Pincode',
    BILLING_PINCODE = 'Billing Pincode',
    STUDENT_STRENGTH = 'Student Strength',
    BOARD_RESULT = '10th Board Result (%)',
    ANNUAL_FEE = 'Annual Fee (₹)',
    TUITION_FEE = 'Tuition Fee (₹)',
    TECH_FEE = 'Tech Fee (₹)',
    SMART_CLASS_FEE = 'Smart Class Fee (₹)',
    DEVELOPMENT_FEE = 'Development Fee (₹)',
    OTHER_FEE = 'Other Fee (₹)',
    SHIPPING_ADDRESS_LINE_1 = 'School Address Line 1',
    SHIPPING_LANDMARK = 'Shipping Landmark',
    SHIPPING_CITY = 'Shipping City',
    BILLING_NAME = 'Billing Name',
    BILLING_ADDRESS_LINE_1 = 'Billing Address Line 1',
    BILLING_ADDRESS_LINE_2 = 'Billing Address Line 2',
    BILLING_LANDMARK = 'Billing Landmark',
    BILLING_CITY = 'Billing City',
    BILLING_STATE = 'Billing State',
    TAN = 'TAN',
    GST = 'GST',
    PAN = 'PAN',
}

export enum EStatus {
    Active = 'Active',
    Inactive = 'Inactive',
    Pending = 'Pending',
}

export enum ELeadStageTitle {
    S0 = 'S0',
    S1 = 'S1',
    S2 = 'S2',
    S3 = 'S3',
    S4 = 'S4',
    S5 = 'S5',
    S6 = 'S6',
    S7 = 'S7',
    S8 = 'S8',
    S9 = 'S9',
}

export enum EUserType {
    RM = 'Regional Manager',
    ZM = 'Zonal Manager',
    SP = 'Sales Person',
    ACAD = 'ACAD Person',
    CSL = 'CSL',
}

export enum ELeadSource {
    ATS = 'ATS',
    REFERRAL = 'Referral',
    INTERNAL = 'Internal (via navigator)',
}

export enum ESortOrder {
    ASC = 'asc',
    DESC = 'desc',
}

export enum EClientScoreRange {
    HIGH = 'high',
    LOW = 'low',
    MEDIUM = 'medium',
}

export enum ELeadStatus {
    LEAD_CREATED = 'Lead Created',
    LEAD_CONTACTED = 'Lead Contacted',
    LEAD_VISITED = 'Lead Visited',
    DEMO_DONE = 'Demo Done',
}

export enum ECallStatus {
    CALL_CONNECTED = 'Call Connected',
    CALL_REJECTED = 'Call Rejected',
    NOT_REACHABLE = 'Not Reachable',
    WRONG_CONTACT_DETAILS = 'Wrong Contact Details',
    INVALID_CONTACT_NUMBER = 'Invalid Contact Number',
    CALL_DROPPED = 'Call Dropped',
    NUMBER_DOESNT_EXIST = "Number Doesn't Exist",
    CUSTOMER_BUSY = 'Customer Busy',
    CALLBACK_REQUESTED = 'Callback Requested',
    NO_RESPONSE = 'No Response',
    SWITCHED_OFF = 'Switched Off',
}

export enum ESortType {
    NAME = 'name',
    TIMEFRAME = 'timeframe',
}

export enum ECommunicationType {
    CALL = 'call',
    EMAIL = 'email',
    IN_PERSON = 'in_person',
    VIRTUAL_MEETING = 'virtual_meeting',
}

export enum EClientSortCriteria {
    SCHOOL_NAME = 'schoolName',
    SCHOOL_NAME_DESC = 'schoolNameDesc',
    STUDENT_STRENGTH = 'studentStrength',
    STUDENT_STRENGTH_DESC = 'studentStrengthDesc',
    BUDGET = 'budget',
    BUDGET_DESC = 'budgetDesc',
    STATUS = 'status',
    STATUS_DESC = 'statusDesc',
    CURRICULUM = 'curriculum',
    CURRICULUM_DESC = 'curriculumDesc',
    LOCATION = 'location',
    LOCATION_DESC = 'locationDesc',
}

export enum ECSLFilter {
    ALL = 'all',
    POTENTIAL = 'potential',
    HIGH_RISK = 'high-risk',
}

export enum EApprovalStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
}

export enum EClientStatus {
    CREATE = 'CREATE',
    PENDING = 'PENDING',
}

export enum ELeadDashboardViewMode {
    KANBAN = 'kanban',
    TABLE = 'table',
}

/** ZM pipeline shell from `?view=`; values match the query string (ignored for RM). */
export enum ELeadDashboardPipelineView {
    MY_LEADS = 'my-leads',
    TEAM = 'team',
    UNASSIGNED = 'unassigned',
}

export enum EDuplicateReasonType {
    PHONE = 'Phone',
    EMAIL = 'Email',
    ORGANISATION_NAME = 'OrganisationName',
    DOMAIN = 'Domain',
    PINCODE = 'Pincode',
    POC_NAME = 'POCName',
    ADDRESS = 'Address',
}

export enum EDuplicateResolutionDialogAction {
    CONTINUE = 'continue',
    BACK = 'back',
    CLOSE = 'close',
}

export enum EAddressType {
    SHIPPING = 'shipping',
    BILLING = 'billing',
    BOTH = 'both',
}

export enum EDemoStatus {
    PENDING = 'pending',
    SCHEDULED = 'scheduled',
    RESCHEDULED = 'rescheduled',
    CANCELLED = 'cancelled',
    COMPLETED = 'completed',
}

/** Lead dashboard S4 proposal button action derived from order_status */
export enum ELeadProposalAction {
    CREATE = 'create',
    EDIT = 'edit',
    REVIEW = 'review',
    /** Proposal is rejected; navigate to proposal dashboard (summary) instead of review page */
    VIEW_DASHBOARD = 'view_dashboard',
}
